const views = {
    dayGridMonth: "dayGridMonth",
    dayGridWeek: "dayGridWeek"
};

export default {
    views
}
